export interface ILeaderboardListItemDTO {
  id: number;
  name: string;
}